import React, { useEffect, useState, useLayoutEffect } from "react";
import analyticsService from "../../services/analytics.service";
import authsService from "../../services/auths.service";
import Googlecharts from "../../components/Googlecharts";

const Client = (props) => {
  const userinfo = authsService.userinfo();
  const client_id = authsService.getclientname();
  const [filterclient, setFilterclient] = useState( client_id === "democlient" ? "" : client_id);

  const [clientoverviewdata, setClientoverviewdata] = useState([]);
  const [filtermonth, setFiltermonth] = useState((new Date().getMonth() + 1) > 12 ? "1" : (new Date().getMonth() + 1));
  const [filteryear, setFilteryear] = useState(new Date().getFullYear());
  const [clientoverviewarr, setClientoverviewarr] = useState({});

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [filter, setFilter] = useState("");
  //use effects
  useEffect(() => {
    console.log("dfrdf",client_id);
    getallClientoverviews();
    getallClientmonthwiseoverview();
  }, []);
  /* useLayoutEffect(() => {
    getallClientoverviews();
  }, [filtermonth, filteryear]); */
  const [clientmonthwiseusage, setClientmonthwiseusage] = useState([]);
  const getallClientoverviews = async () => {
    var data = {
      limit: 40,
      page: 1,
      filter: "",
      filterclient: filterclient,
      filtermonth: filtermonth,
      filteryear: filteryear,
      search: "",
      between: "",
      sort: "",
      group: "client_id",
    };
    return await analyticsService
      .clientAirconoverview(data)
      .then((res) => {
        console.log(res.data.result);
        if (res.data.result) {
          setClientoverviewarr(res.data.result.data[0]);
          console.log(res.data.result.data[0]);
        } else {
          setClientoverviewarr({});
        }
      })
      .catch((err) => {
        setClientoverviewarr({});
      });
  };
  //get allclient
  const getallClientoverview = async () => {
    var data = {
      limit: 40,
      page: 1,
      filter: "",
      filterclient: filterclient,
      filtermonth: filtermonth,
      filteryear: filteryear,
      search: "",
      between: "",
      sort: "",
      group: "client_id",
    };
    return await analyticsService
      .clientAirconoverview(data)
      .then((res) => {
        console.log(res.data.result);
        if (res.data.result) {
          setClientoverviewarr(res.data.result.data[0]);
        } else {
          setClientoverviewarr({});
        }
      })
      .catch((err) => {
        setClientoverviewarr({});
      });
  };
  //get allclient
  const getallClientmonthwiseoverview = async () => {
    var data = {
      limit: 40,
      page: 1,
      filter: "",
      filterclient: userinfo.user_id,
      search: "",
      between: "",
      sort: "",
      group: "month_name",
    };
    return await analyticsService
      .clientAirconmonthwiseoverview(data)
      .then((res) => {
        console.log(res.data.result);
        if (res.data.result) {
          const data = [
            ["Month", "Total Completed"],
            ...res.data.result.data.map((d) => [
              d.month_label,
              Number(d.client_total_service),
            ]),
          ];

          setClientmonthwiseusage(data);
        } else {
          setClientmonthwiseusage([]);
        }
      })
      .catch((err) => {
        setClientmonthwiseusage([]);
      });
  };
  const monthchangefn = (value) => {
    if (value == "c") {
      setFiltermonth(new Date().getMonth());
      console.log(new Date().getMonth());
    } else {
      setFiltermonth(new Date().getMonth() - 1);
      console.log(new Date().getMonth() - 1);
    }
  };
  const selectrandomcolor = () => {
    const colors = [
      "#5EE5FA",
      "#5EC4FA",
      "#5E9EFA",
      "#5E73FA",
      "#5EF1FA",
      "#5EFAE0",
      "#605EFA",
    ];

    const random = Math.floor(Math.random() * colors.length);
    return random, colors[random];
  };
  return (
    <div>
      <div className="d-flex flex-wrap">
        <div className="flex-fill">
          <h1>
            OVERVIEW
          </h1>
        </div>
        <div className="d-none">
          <div
            className="btn-group m-1"
            role="group"
            aria-label="Basic radio toggle button group"
          >
            <input
              type="radio"
              className="btn-check"
              name="btnradio"
              id="btnradio1"
              onChange={(e) => monthchangefn("c")}
              autoComplete="off"
              checked={new Date().getMonth() == filtermonth ? true : false}
            />
            <label className="btn btn-outline-secondary" htmlFor="btnradio1">
              This Month
            </label>
            <input
              type="radio"
              className="btn-check"
              name="btnradio"
              onChange={(e) => monthchangefn("")}
              id="btnradio2"
              autoComplete="off"
              checked={new Date().getMonth() - 1 == filtermonth ? true : false}
            />
            <label className="btn btn-outline-secondary" htmlFor="btnradio2">
              Last Month
            </label>
          </div>
        </div>
      </div>

      <div className="row p-2">
          <div className=" p-1 col-md-3">
            <div style={{ borderRadius: 10 }}>
              <div className="bg-white rounded d-flex flex-wrap p-1">
                <div className="ps-2" style={{ fontSize: 20 }}>
                  <i className="fa fa-codiepie"></i>
                </div>
                <div className="flex-fill ps-4">
                  <div style={{ fontSize: 20, fontWeight: 600 }}>
                    {clientoverviewarr.client_total_aircon_unit}
                  </div>
                  <div>Aircon Unit</div>
                </div>
              </div>
            </div>
          </div>
          <div className=" p-1 col-md-3">
            <div style={{ borderRadius: 10 }}>
              <div className="bg-white rounded d-flex flex-wrap p-1">
                <div className="ps-2" style={{ fontSize: 20 }}>
                  <i className="fa fa-map-marker"></i>
                </div>
                <div className="flex-fill ps-4">
                  <div style={{ fontSize: 20, fontWeight: 600 }}>
                    {clientoverviewarr.client_total_aircon}
                  </div>
                  <div>Location</div>
                </div>
              </div>
            </div>
          </div>

          <div className=" p-1 col-md-3 ">
            <div style={{ borderRadius: 10 }}>
              <div className="bg-white rounded d-flex flex-wrap p-1">
                <div className="ps-2" style={{ fontSize: 20 }}>
                  <i className="fa fa-thumbs-up"></i>
                </div>
                <div className="flex-fill ps-4">
                  <div style={{ fontSize: 20, fontWeight: 600 }}>
                    {clientoverviewarr.client_total_service}{" "}
                    <span
                      style={{ fontSize: 12, fontWeight: 400 }}
                      className="fw-sm"
                    >
                      Maintenance &nbsp;
                      <span className="badge bg-secondary">  {clientoverviewarr.client_total_maintenance}</span>&nbsp; Issue &nbsp;
                      <span className="badge bg-secondary">   {clientoverviewarr.client_total_issue}</span>
                    </span>
                  </div>
                  <div>Completed</div>
                </div>
              </div>
            </div>
          </div>
          <div className=" p-1 col-md-3 ">
            <div style={{ borderRadius: 10 }}>
              <div className="bg-white rounded d-flex flex-wrap p-1">
                <div className="ps-2" style={{ fontSize: 20 }}>
                  <i className="fa fa-thumbs-down"></i>
                </div>
                <div className="flex-fill ps-4">
                  <div style={{ fontSize: 20, fontWeight: 600 }}>
                    {clientoverviewarr.client_total_aircon -
                      clientoverviewarr.client_total_service
                      ? clientoverviewarr.client_total_aircon -
                      clientoverviewarr.client_total_service
                      : 0}
                  </div>
                  <div>Pending</div>
                </div>
              </div>
            </div>
          </div>
          <div className=" p-1 col-md-3 ">
            <div style={{ borderRadius: 10 }}>
              <div className="bg-white rounded d-flex flex-wrap p-1">
                <div className="ps-2" style={{ fontSize: 20 }}>
                  <i className="fa fa-money"></i>
                </div>
                <div className="flex-fill ps-4">
                  <div style={{ fontSize: 20, fontWeight: 600 }}>
                    {clientoverviewarr.client_total_amount}
                  </div>
                  <div>Issue Cost</div>
                </div>
              </div>
            </div>
          </div>
        </div>

      <div className="row p-2 d-none">
        <div className=" p-1 col-md-3">
          <div style={{ borderRadius: 10 }}>
            <div className="bg-white rounded d-flex flex-wrap p-1">
              <div className="ps-2" style={{ fontSize: 20 }}>
                <i className="fa fa-codiepie"></i>
              </div>
              <div className="flex-fill ps-4">
                <div style={{ fontSize: 20, fontWeight: 600 }}>
                  {clientoverviewarr?.client_total_aircon_unit}
                </div>
                <div>Total Aircon</div>
              </div>
            </div>
          </div>
        </div>
        <div className=" p-1 col-md-3 ">
          <div style={{ borderRadius: 10 }}>
            <div className="bg-white rounded d-flex flex-wrap p-1">
              <div className="ps-2" style={{ fontSize: 20 }}>
                <i className="fa fa-thumbs-up"></i>
              </div>
              <div className="flex-fill ps-4">
                <div style={{ fontSize: 20, fontWeight: 600 }}>
                  {clientoverviewarr?.client_total_service}{" "}
                  <span
                    style={{ fontSize: 12, fontWeight: 400 }}
                    className="fw-sm"
                  >
                    (Maintenance - {clientoverviewarr?.client_total_maintenance}
                    , Issue - {clientoverviewarr?.client_total_issue})
                  </span>
                </div>
                <div>Completed</div>
              </div>
            </div>
          </div>
        </div>
        <div className=" p-1 col-md-3 ">
          <div style={{ borderRadius: 10 }}>
            <div className="bg-white rounded d-flex flex-wrap p-1">
              <div className="ps-2" style={{ fontSize: 20 }}>
                <i className="fa fa-thumbs-down"></i>
              </div>
              <div className="flex-fill ps-4">
                <div style={{ fontSize: 20, fontWeight: 600 }}>
                  {clientoverviewarr.client_total_aircon_unit -
                    clientoverviewarr.client_total_service
                    ? clientoverviewarr.client_total_aircon_unit -
                    clientoverviewarr.client_total_service
                    : 0}
                </div>
                <div>Pending Unit</div>
              </div>
            </div>
          </div>
        </div>
        <div className=" p-1 col-md-3 ">
          <div style={{ borderRadius: 10 }}>
            <div className="bg-white rounded d-flex flex-wrap p-1">
              <div className="ps-2" style={{ fontSize: 20 }}>
                <i className="fa fa-money"></i>
              </div>
              <div className="flex-fill ps-4">
                <div style={{ fontSize: 20, fontWeight: 600 }}>
                  {clientoverviewarr?.client_total_amount}
                </div>
                <div>Total Cost</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div className="row">
          <div className="col-md-4">
            <div className="p-2">
              <div className="mb-2">Completion in Percentage</div>
              <Googlecharts
                com_data={[
                  ["name", "type"],
                  ["Total Unit", clientoverviewarr?.client_total_aircon_unit - clientoverviewarr?.client_total_service],
                  ["completed", clientoverviewarr?.client_total_service],
                ]}
                chart_type="PieChart"
                haxis="Client"
                vaxis="Expanses"
              />
            </div>
          </div>
          <div className="col-md-8">
            <div className="p-2">
              <div className="mb-2">Monthwise Completion</div>
              <Googlecharts
                com_data={clientmonthwiseusage}
                chart_type="AreaChart"
                haxis="Month"
                vaxis="flow"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Client;
